import React, { useState } from "react";
import {
  FormContainer,
  FormHeader,
  FormField,
  SubmitButton,
  Message,
  ValidationError,
} from "./EditarConsultaForm.styles";
import api from "../../services/api";
import { PROJECT_NAME } from "../../constants/project";

const formatToInputDate = (dateStr) => {
  // Verifica se a data está no formato dd/mm/yyyy
  if (!dateStr || typeof dateStr !== "string") return "";

  const [day, month, year] = dateStr.split('/');
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};

const EditarConsultaForm = ({ consulta, gravidezId, dataFim, onClose, onAtualizar }) => {
  const [formValues, setFormValues] = useState({
    data_consulta: formatToInputDate(consulta.data),
    profissional: consulta.profissional,
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [validationErrors, setValidationErrors] = useState({});

  // Data de encerramento da gestação (dd/mm/yyyy), quando houver.
  const dataFimInput = formatToInputDate(dataFim);

  const validateDataConsulta = (data) => {
    if (!data) return "";

    const dataConsulta = new Date(data);
    const dataMinima = new Date("2025-01-01");

    if (dataConsulta < dataMinima) {
      return `Não é permitido adicionar consulta com data anterior a 01/01/2025, que é a data inicial do programa ${PROJECT_NAME}.`;
    }

    if (dataFimInput && dataConsulta > new Date(dataFimInput)) {
      return `Não é permitido registrar consulta com data posterior à data de encerramento da gestação (${dataFim}).`;
    }

    return "";
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
    
    // Validação em tempo real para data_consulta
    if (name === "data_consulta") {
      const error = validateDataConsulta(value);
      setValidationErrors((prev) => ({
        ...prev,
        data_consulta: error,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSuccessMessage("");
    setErrorMessage("");
    setValidationErrors({});

    // Validar data da consulta antes de enviar
    const dataError = validateDataConsulta(formValues.data_consulta);
    if (dataError) {
      setValidationErrors({ data_consulta: dataError });
      setIsSubmitting(false);
      return;
    }

    try {
      const response = await api.put(
        `/gestante/gravidez/${gravidezId}/consulta/${consulta.id}/update`,
        {
          data_consulta: formValues.data_consulta,
          profissional: formValues.profissional,
        }
      );

      if (response.status === 200) {
        setSuccessMessage("Consulta atualizada com sucesso!");
        setTimeout(() => {
          onAtualizar();  // Atualiza a timeline
          onClose();
        }, 1000);
      } else {
        setErrorMessage(response.data.detail || "Erro ao atualizar.");
      }
    } catch (error) {
      setErrorMessage(error.response?.data?.detail || "Erro ao conectar com o servidor.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <FormContainer>
      <FormHeader>Editar Consulta</FormHeader>
      <form onSubmit={handleSubmit}>
        <FormField>
          <label>Data da Consulta:</label>
          <input
            type="date"
            name="data_consulta"
            value={formValues.data_consulta}
            onChange={handleChange}
            max={dataFimInput || undefined}
            required
          />
          {validationErrors.data_consulta && (
            <ValidationError>{validationErrors.data_consulta}</ValidationError>
          )}
        </FormField>
        <FormField>
          <label>Profissional:</label>
          <input
            type="text"
            name="profissional"
            value={formValues.profissional}
            onChange={handleChange}
            required
          />
        </FormField>
        <SubmitButton type="submit" disabled={isSubmitting}>
          {isSubmitting ? "Salvando..." : "Salvar Alterações"}
        </SubmitButton>
      </form>
      {successMessage && <Message>{successMessage}</Message>}
      {errorMessage && <Message isError>{errorMessage}</Message>}
    </FormContainer>
  );
};

export default EditarConsultaForm;
